export const APPLICANT_LOADING = "APPLICANT_LOADING";
export const APPLICANT_RESET = "APPLICANT_RESET";
export const GET_APPLICANT = "GET_APPLICANT";
export const GET_APPLICANT_ONE = "GET_APPLICANT_ONE";
export const GET_APPLICANT_SUCCESS = "GET_APPLICANT_SUCCESS";
export const GET_APPLICANT_FAIL = "GET_APPLICANT_FAIL";
export const DELETE_APPLICANT = "DELETE_APPLICANT"
export const DELETE_APPLICANT_SUCCESS = "DELETE_APPLICANT_SUCCESS"
export const DELETE_APPLICANT_FAIL = "DELETE_APPLICANT_FAIL"
export const UPDATE_APPLICANT = "UPDATE_APPLICANT"
export const UPDATE_APPLICANT_SUCCESS = "UPDATE_APPLICANT_SUCCESS"
export const UPDATE_APPLICANT_FAIL = "UPDATE_APPLICANT_FAIL"
export const ADD_NEW_APPLICANT = "ADD_NEW_APPLICANT"
export const ADD_APPLICANT_SUCCESS = "ADD_APPLICANT_SUCCESS"
export const ADD_APPLICANT_FAIL = "ADD_APPLICANT_FAIL"
export const APPLICANT_RESET_CREATE = "APPLICANT_RESET_CREATE"